import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

const LegalLayout = ({ title, lastUpdated, children }) => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F7F2EC] dark:bg-background">
      {/* Nav */}
      <nav className="bg-[#F7F2EC]/90 dark:bg-card/90 backdrop-blur-xl border-b border-[#DDD4C8]/30 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-6 flex items-center justify-between h-[64px]">
          <Link to="/" className="flex items-center gap-2.5">
            <img src="/lumera-logo.png" alt="Lumera" className="w-8 h-8 rounded-full" />
            <span className="text-lg font-serif font-semibold text-[#4A3525] tracking-tight">Lumera</span>
          </Link>
          <button onClick={() => navigate(-1)} className="flex items-center gap-1.5 text-xs font-sans text-[#8A7D72] hover:text-[#4A3525] transition-colors">
            <ArrowLeft className="w-3.5 h-3.5" /> Back
          </button>
        </div>
      </nav>

      {/* Content */}
      <article className="max-w-4xl mx-auto px-6 py-12 md:py-16">
        <div className="bg-white dark:bg-card rounded-2xl p-8 md:p-12 shadow-sm">
        <header className="mb-10">
          <h1 className="text-3xl md:text-4xl font-serif font-bold text-[#4A3525] tracking-tight mb-3">{title}</h1>
          {lastUpdated && (
            <p className="font-sans text-sm text-[#8A7D72]">Last updated: {lastUpdated}</p>
          )}
        </header>

        <div className="prose prose-stone prose-sm max-w-none
          prose-headings:font-serif prose-headings:tracking-tight prose-headings:text-[#4A3525]
          prose-h2:text-xl prose-h2:mt-10 prose-h2:mb-4
          prose-h3:text-base prose-h3:mt-6 prose-h3:mb-2
          prose-p:font-sans prose-p:text-[#8A7D72] prose-p:leading-relaxed prose-p:text-sm
          prose-li:font-sans prose-li:text-[#8A7D72] prose-li:text-sm
          prose-a:text-[#8C7A66] prose-a:no-underline hover:prose-a:underline
          prose-strong:text-[#4A3525]
        ">
          {children}
        </div>
        </div>
      </article>

      {/* Footer */}
      <footer className="border-t border-[#DDD4C8]/50 py-8">
        <div className="max-w-4xl mx-auto px-6 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs font-sans text-[#8A7D72]">&copy; {new Date().getFullYear()} Create by Lumera. All rights reserved.</p>
          <div className="flex flex-wrap items-center gap-4">
            <Link to="/privacy" className="text-xs font-sans text-[#8A7D72] hover:text-[#8C7A66] transition-colors">Privacy Policy</Link>
            <Link to="/terms" className="text-xs font-sans text-[#8A7D72] hover:text-[#8C7A66] transition-colors">Terms of Service</Link>
            <Link to="/license-terms" className="text-xs font-sans text-[#8A7D72] hover:text-[#8C7A66] transition-colors">License Terms</Link>
            <Link to="/refund-policy" className="text-xs font-sans text-[#8A7D72] hover:text-[#8C7A66] transition-colors">Refund Policy</Link>
            <Link to="/cookies" className="text-xs font-sans text-[#8A7D72] hover:text-[#8C7A66] transition-colors">Cookie Policy</Link>
            <Link to="/contact" className="text-xs font-sans text-[#8A7D72] hover:text-[#8C7A66] transition-colors">Contact</Link>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LegalLayout;
